export default __webpack_public_path__ + "static/media/cover2.510a8050.jpg";